export default "__VITE_ASSET__c48e936e__"